/**
 * Initializes form validation for phone number inputs.
 * This function sets up jQuery validation on forms with the data attribute `data-validator='phone'`.
 * It ensures that phone numbers are entered in the correct format (e.g., (212) 555-6789) and provides feedback to users.
 * 
 * Validation rules:
 * - Phone number is required.
 * - Phone number must match the custom phone number format.
 * 
 * Feedback:
 * - If the phone number is invalid, an error message is displayed next to the input field.
 * - If the phone number is valid, any error messages are hidden.
 * 
 * Custom validation method:
 * - `customphone`: Validates the phone number format to ensure it matches the pattern (###) ###-####.
 * 
 * @function initFormValidation
 */

export function initFormValidation() {
$("form[data-validator='phone']").each(function () {
      $(this).validate({
        ignore: '.ignore',
        rules: {
          phone: {
            required: true,
            customphone: true,
          },
        },
        messages: {
          phone: 'Please enter a valid phone number. e.g. (212) 555-6789',
        },
        showErrors: function (errorMap, errorList) {
          $.each(this.successList, function (index, value) {
            const $inputs = $('input[name="' + value.name + '"]');
            const $labels = $('label[for="' + value.name + '"]');
            $inputs.removeClass('has-error');
            $labels.addClass('is-hidden');
          });

          $.each(errorList, function (index, value) {
            const $inputs = $('input[name="' + value.element.name + '"]');
            const $labels = $('label[for="' + value.element.name + '"]');
            $inputs.addClass('has-error');
            $labels.removeClass('is-hidden');
            $labels.text(value.message);
          });
        },
        submitHandler: function (form) {
          event.preventDefault();
          var num = $(form)
            .find("input[name='phone']")
            .val()
            .replace(/[^0-9]/g, '');
          if (num.length > 0) {
            $(form).find('label.error').addClass('is-hidden');
            window.location.href = $(form).data('nextpage') + '?phone=' + num;
          }
        },
      });
    });

  $.validator.addMethod(
    'customphone',
    function (phone_number, element) {
      phone_number = phone_number.replace(/\s+/g, '');
      return (
        this.optional(element) ||
        (phone_number.length > 9 &&
          phone_number.match(
            /^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]([02-9]\d|1[02-9])-?\d{4}$/
          ))
      );
    },
    'Please enter a valid phone number. e.g. (212) 555-6789'
  );


}